/**
 * Estilos + script para "Abrir atividade Moodle": linha estilo lista de atividades do Moodle,
 * abre na mesma aba (padrão) ou em nova janela conforme data-open-in-new-tab no HTML exportado.
 *
 * resolveTargetUrl usa M.cfg.wwwroot quando existir (Moodle em subpasta).
 * Pills .gma-badge--live consultam /local/geppetto/ajax/completion_status.php
 * (requer window.geppettoMoodleCourseId ou M.cfg.courseId).
 */

/** Extrai CMID de URLs típicas de atividades (/mod/.../view.php?id=). */
export function extractMoodleActivityCmidFromHref(href) {
  const s = String(href || '');
  if (!/\/mod\//.test(s)) return '';
  const m = s.match(/[?&]id=(\d+)/);
  return m ? m[1] : '';
}

export const GEPPETTO_MOODLE_ACTIVITY_EXPORT_SCRIPT = `
<style>
  .geppetto-moodle-activity-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    cursor: pointer;
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    transition: background-color 0.15s ease, border-color 0.15s ease;
  }
  .geppetto-moodle-activity-row:hover {
    background: #f8f9fa;
    border-color: #ced4da;
  }
  .geppetto-moodle-activity-row:focus {
    outline: 2px solid #0f6cbf;
    outline-offset: 2px;
  }
  .gma-icon-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .gma-icon-wrap svg {
    display: block;
    flex-shrink: 0;
  }
  .gma-body {
    flex: 1;
    min-width: 0;
  }
  .gma-title {
    display: block;
    font-size: 1.0625rem;
    font-weight: 500;
    color: #1d2125;
    line-height: 1.35;
  }
  .gma-meta {
    display: block;
    margin-top: 4px;
    font-size: 0.875rem;
    color: #6a737b;
    line-height: 1.45;
  }
  .gma-badge {
    flex-shrink: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: #6a737b;
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid #dee2e6;
    background: #fff;
  }
  .gma-badge--complete {
    color: #0f5132;
    border-color: #badbcc;
    background: #d1e7dd;
  }
  @media (max-width: 767px) {
    .geppetto-moodle-activity-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
</style>
<script>
(function(){
  function getGeppettoWwwroot(){
    var a = window.geppettoMoodleWwwroot;
    if (a != null && String(a).trim() !== '') return String(a).replace(/\\/$/, '');
    if (typeof M !== 'undefined' && M.cfg && M.cfg.wwwroot) return String(M.cfg.wwwroot).replace(/\\/$/, '');
    return '';
  }
  function getGeppettoSesskey(){
    var a = window.geppettoMoodleSesskey;
    if (a != null && String(a).trim() !== '') return String(a);
    if (typeof M !== 'undefined' && M.cfg && M.cfg.sesskey) return String(M.cfg.sesskey);
    return '';
  }
  function getSameOriginTop(){
    try {
      if(window.top && window.top !== window && window.location.origin === window.top.location.origin) return window.top;
    } catch(e) {}
    return window;
  }
  function looksLikePathTraversal(s){
    try {
      var d = decodeURIComponent(s);
      if (d.indexOf('../') !== -1) return true;
      if (d.indexOf('..\\\\') !== -1) return true;
      if (d.indexOf('/..') !== -1) return true;
      return false;
    } catch(e) { return false; }
  }
  function resolveTargetUrl(href){
    var s = String(href||'').trim();
    if(!s) return '';
    if(/^javascript:/i.test(s)) return '';
    if(looksLikePathTraversal(s)) return '';
    if(/^https?:\\/\\//i.test(s)) return s;
    if(s.substr(0,2) === '//') return '';
    var wwwroot = getGeppettoWwwroot();
    if(wwwroot){
      var path = s.replace(/^\\/+/, '');
      try { return new URL(path, wwwroot + '/').href; } catch(e1) {}
    }
    if(s.charAt(0) !== '/') s = '/' + s.replace(/^\\/+/, '');
    try { return new URL(s, window.location.origin).href; }
    catch(e2){ return ''; }
  }
  function openActivity(url, newTab){
    if(!url) return;
    var topW = getSameOriginTop();
    if(newTab){
      try {
        topW.open(url, '_blank');
      } catch(e1) {
        try { window.open(url, '_blank'); } catch(e2) {}
      }
      return;
    }
    try {
      topW.location.href = url;
    } catch(e3) {
      try { window.location.href = url; } catch(e4) {}
    }
  }
  function shouldOpenInNewTab(el){
    var v = el.getAttribute('data-open-in-new-tab');
    if(v === null || v === '') return true;
    return v === '1' || v === 'true';
  }
  function onActivate(el){
    var raw = el.getAttribute('data-activity-href') || '';
    var url = resolveTargetUrl(raw);
    if(!url){
      try { window.alert((window.geppettoMoodleActivityNoUrl) || 'Configure a URL relativa da atividade nas propriedades do bloco no Geppetto.'); } catch(e) {}
      return;
    }
    openActivity(url, shouldOpenInNewTab(el));
  }
  document.addEventListener('click', function(e){
    var el = e.target && e.target.closest ? e.target.closest('.geppetto-moodle-activity-row') : null;
    if(!el) return;
    e.preventDefault();
    e.stopPropagation();
    onActivate(el);
  }, true);
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target && e.target.closest ? e.target.closest('.geppetto-moodle-activity-row') : null;
    if(!el || el !== e.target) return;
    e.preventDefault();
    onActivate(el);
  });

  function getGeppettoCourseId(){
    var a = window.geppettoMoodleCourseId;
    if (a != null && String(a).trim() !== '') return parseInt(a, 10) || null;
    if (typeof M !== 'undefined' && M.cfg && M.cfg.courseId != null) {
      var b = parseInt(M.cfg.courseId, 10);
      return b > 0 ? b : null;
    }
    return null;
  }
  function syncActivityCompletion(){
    var courseId = getGeppettoCourseId();
    if (!courseId) return;
    var sesskey = getGeppettoSesskey();
    if (!sesskey) return;
    var nodes = document.querySelectorAll('.gma-badge--live[data-cmid]');
    if (!nodes.length) return;
    var cmids = [];
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].getAttribute('data-cmid');
      if (id && cmids.indexOf(id) < 0) cmids.push(id);
    }
    if (!cmids.length) return;
    var base = getGeppettoWwwroot();
    if (!base) return;
    function makeFd(){
      var fd = new FormData();
      fd.append('sesskey', sesskey);
      fd.append('courseid', String(courseId));
      for (var j = 0; j < cmids.length; j++) fd.append('cmids[]', cmids[j]);
      return fd;
    }
    var endpoints = [
      '/local/geppetto/ajax/completion_status.php',
      '/mod/gepettoresource/ajax/completion_status.php'
    ];
    function tryEndpoint(idx){
      if (idx >= endpoints.length) return Promise.reject(new Error('no completion endpoint'));
      return fetch(base + endpoints[idx], { method: 'POST', body: makeFd(), credentials: 'same-origin' })
        .then(function(r){
          if (!r.ok) return Promise.reject(new Error('completion http ' + r.status));
          return r.json();
        })
        .catch(function(){ return tryEndpoint(idx + 1); });
    }
    tryEndpoint(0)
      .then(function(data){
        if (!data || !data.success || !data.items) return;
        for (var k = 0; k < nodes.length; k++) {
          var el = nodes[k];
          var cid = el.getAttribute('data-cmid');
          var st = data.items[cid];
          if (!st || !st.tracked) continue;
          var pend = el.getAttribute('data-label-pending') || '';
          var comp = el.getAttribute('data-label-complete') || '';
          if (st.complete) {
            el.textContent = comp;
            el.classList.add('gma-badge--complete');
          } else {
            el.textContent = pend;
            el.classList.remove('gma-badge--complete');
          }
        }
      })
      .catch(function(){});
  }
  function runCompletionSync(){
    try { syncActivityCompletion(); } catch(e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCompletionSync);
  } else {
    runCompletionSync();
  }
  window.addEventListener('focus', runCompletionSync);
  window.addEventListener('pageshow', function(ev){ if (ev && ev.persisted) runCompletionSync(); });
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') runCompletionSync();
  });
  window.addEventListener('message', function(ev){
    if (!ev || !ev.data || ev.data.type !== 'geppettoRunActivityCompletionSync') return;
    runCompletionSync();
  });
  setInterval(runCompletionSync, 15000);
})();
</script>`;
